import { gql } from '@apollo/client';
import { useRef } from 'react';

import { queryClient, useQuery } from '@fhs/client';
import { client } from '@fhs-legacy/frontend/src/state/graphql/client';

import { GetGiftCardBalanceInput, GetGiftCardBalancePayload } from '../utils/types';

export const GetGiftCardBalanceQuery = gql`
  query GetGiftCardBalance($input: GetGiftCardBalanceInput) @gateway @authRequired {
    getGiftCardBalance(input: $input) {
      giftCard {
        currentBalance
      }
    }
  }
`;

const QUERY_KEY = 'getBalance';

export const useGetBalanceQuery = ({
  token,
  pin,
  expiryDate,
  isPhysicalCardBalanceCheck,
  fetchBalance = true,
}: GetGiftCardBalanceInput & { fetchBalance?: boolean }) => {
  const queryKey = [QUERY_KEY, token, pin, expiryDate, isPhysicalCardBalanceCheck];
  const prevFetchBalance = useRef(false);

  // Clear cache when fetchBalance transitions from false to true
  // This is to avoid cached results from previous balance checks
  if (fetchBalance && !prevFetchBalance.current) {
    queryClient.removeQueries({ queryKey });
  }
  prevFetchBalance.current = fetchBalance;

  return useQuery({
    enabled: fetchBalance,
    queryKey,
    staleTime: 0,
    gcTime: 0,
    retry: false,
    queryFn: async () => {
      const { data } = await client.query({
        query: GetGiftCardBalanceQuery,
        fetchPolicy: 'no-cache',
        variables: {
          input: {
            token,
            pin,
            expiryDate,
            isPhysicalCardBalanceCheck,
          },
        },
      });
      return data?.getGiftCardBalance?.giftCard as GetGiftCardBalancePayload;
    },
  });
};
